import { Injectable, inject } from '@angular/core';
import { ApiService } from '@cropx-web/services/network/ApiService';
import {
  Action,
  Selector,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Product {
  const type = 'product';

  export class GetFertilizers {
    static readonly type = `[${type}] GetFertilizers`;

    constructor() {}
  }

  export class SetFertilizers {
    static readonly type = `[${type}] SetFertilizers`;

    constructor(public fertilizers: Fertilizer[]) {}
  }
}

export interface ProductStateModel {
  fertilizers: Fertilizer[];
  loading: boolean;
}

export type FertilizersResponse = {
  content: {
    fertilizers: Fertilizer[];
  };
  timestamp: number;
};

export type Fertilizer = {
  decompYear1: number;
  decompYear2: number;
  id: number;
  name: string;
  nitroNh2: number;
  nitroNh4: number;
  nitroNo3: number;
  productType: string;
  state: string;
  totalN: number;
};

@State<ProductStateModel>({
  name: 'products',
  defaults: {
    loading: false,
    fertilizers: [],
  },
})
@Injectable()
export class ProductState {
  private apiService = inject(ApiService);

  @Action(Product.GetFertilizers)
  getFertilizer(
    ctx: StateContext<ProductStateModel>,
  ): Observable<FertilizersResponse> {
    ctx.patchState({ loading: true });
    return this.apiService.fieldApi.getFertilizerObservable().pipe(
      tap((response: FertilizersResponse) => {
        ctx.dispatch(new Product.SetFertilizers(response.content.fertilizers));
      }),
    );
  }

  @Action(Product.SetFertilizers)
  setFertilizer(
    ctx: StateContext<ProductStateModel>,
    action: Product.SetFertilizers,
  ): void {
    ctx.patchState({ loading: false });
    ctx.patchState({ fertilizers: action.fertilizers });
  }
}

export class ProductStateSelectors {
  static slices = createPropertySelectors<ProductStateModel>(ProductState);

  @Selector([ProductState])
  static fertilizers(state: ProductStateModel): Fertilizer[] {
    return state.fertilizers;
  }
}
